import React from 'react';
import Footer from '../LayoutComponents/Footer';
import Header from '../LayoutComponents/Header';
import Banner from '../CommonComponents/Banner';

const TermsAndConditions = () => {
  return (
    <>
    <Header />
      <Banner 
        title="Terms & Conditions"
        customHeight={true}
        textBlack={true}
      />

      <section className="section zigzag-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p><span style={{ fontWeight: 400 }}>Effective Date: 29 January 2025</span></p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Welcome to cloudmingle ("we", "us", "our"). By accessing and using our website, 
                  you agree to comply with and be bound by the following terms and conditions ("Terms"). 
                  Please read them carefully.
                </span>
              </p>
              
              <p><strong>Use of the Website:</strong></p>
              <ol>
                <li style={{ fontWeight: 400 }}>
                  <strong>Eligibility:</strong>
                  <span style={{ fontWeight: 400 }}> You must be at least 18 years old to use our website and services.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>Account Registration:</strong>
                  <span style={{ fontWeight: 400 }}> When creating an account, you agree to provide accurate and 
                  complete information. You are responsible for maintaining the confidentiality of your account 
                  information and for all activities that occur under your account.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>Prohibited Activities:</strong>
                  <span style={{ fontWeight: 400 }}> You agree not to use the website for any unlawful purpose, 
                  to violate any laws, or to engage in any activity that disrupts or interferes with the 
                  website's functionality.</span>
                </li>
              </ol>
              
              <p><strong>Content and Intellectual Property:</strong></p>
              <ol>
                <li style={{ fontWeight: 400 }}>
                  <strong>Ownership:</strong>
                  <span style={{ fontWeight: 400 }}> All content on our website, including text, graphics, logos, 
                  and images, is the property of cloudmingle and is protected by intellectual property laws.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>User-Generated Content:</strong>
                  <span style={{ fontWeight: 400 }}> By submitting content (e.g., reviews, comments) to our website, 
                  you grant us a non-exclusive, royalty-free, perpetual, and worldwide license to use, modify, and 
                  display such content.</span>
                </li>
              </ol>
              
              <p><strong>Booking and Payments:</strong></p>
              <ol>
                <li style={{ fontWeight: 400 }}>
                  <strong>Booking Services:</strong>
                  <span style={{ fontWeight: 400 }}> Our website may facilitate bookings with third-party hotels. 
                  By making a booking, you agree to comply with the terms and conditions of the respective hotel.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>Payments:</strong>
                  <span style={{ fontWeight: 400 }}> You agree to provide accurate payment information and authorize 
                  us to charge your payment method for bookings and any applicable fees.</span>
                </li>
              </ol>
              
              <p><strong>Disclaimers and Limitation of Liability:</strong></p>
              <ol>
                <li style={{ fontWeight: 400 }}>
                  <strong>No Warranty:</strong>
                  <span style={{ fontWeight: 400 }}> Our website and services are provided "as is" without any 
                  warranties of any kind. We do not guarantee the accuracy or completeness of the information 
                  on our website.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>Limitation of Liability:</strong>
                  <span style={{ fontWeight: 400 }}> To the fullest extent permitted by law, cloudmingle shall 
                  not be liable for any indirect, incidental, special, or consequential damages arising out of or 
                  in connection with your use of our website or services.</span>
                </li>
              </ol>
              
              <p>
                <strong>Indemnification:</strong>
                <span style={{ fontWeight: 400 }}> You agree to indemnify and hold cloudmingle harmless from 
                any claims, damages, losses, or expenses arising out of your use of the website, your violation of 
                these Terms, or your infringement of any rights of another.</span>
              </p>
              
              <p>
                <strong>Governing Law:</strong>
                <span style={{ fontWeight: 400 }}> These Terms shall be governed by and construed in accordance with 
                the laws of Australia, without regard to its conflict of law principles.</span>
              </p>
              
              <p>
                <strong>Changes to These Terms:</strong>
                <span style={{ fontWeight: 400 }}> We may update these Terms from time to time. Any changes will be 
                posted on this page with an updated effective date. Your continued use of the website after any 
                changes constitutes your acceptance of the new Terms.</span>
              </p>
              
              <p>
                <strong>Contact Us:</strong>
                <span style={{ fontWeight: 400 }}> If you have any questions or concerns about these Terms, please 
                contact us at <a href="mailto:info@cloudmingle.site">info@cloudmingle.site</a></span>
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default TermsAndConditions;